<!-- 最值->根据设备号和类型查询最大最小值-->
<template>
  <div class="virtualDeviceRTValueBody">
    <elCheckBoxTree slot="tree" :dataList='virtualDeviceList'></elCheckBoxTree>
    <div class="VirtualDeviceRTValueRigth" slot="body">
      <!--头部选择功能-->
      <div class="buttonLine">
        <label>应用类型组：</label>
        <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small' style="width: 155px;">
          <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
          <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <span v-if="apptypeValue.length==1&&options.length">
          <label>应用类型：</label>
          <el-select v-model="apptypeValue2" multiple collapse-tags placeholder="请选择" size='small'
            style="width: 155px;">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.no">
            </el-option>
          </el-select>
        </span>
        <span class="box">
          <span class="radio_box">
            <el-radio style="margin-right:5px" v-model="timeInterval" label="year">年</el-radio>
            <el-radio style="margin-right:5px" v-model="timeInterval" label="monthrange">月</el-radio>
            <el-radio style="margin-right:5px" v-model="timeInterval" label="daterange">日</el-radio>
          </span>
        </span>
        <span class="box">
          时间
          <span>
            <el-date-picker :class="{'miniWidth':timeInterval == 'year'}" size="mini" v-model="value1"
              :type="timeInterval" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>-
            <el-date-picker class="miniWidth" size="mini" v-if="timeInterval == 'year'" v-model="value2"
              :type="timeInterval" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </span>
        </span>

        <div class="box">
          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList" style="margin-right: 20px;"
            :loading="loading">查询</el-button>
        </div>
      </div>
      <!--表格显示数据-->
      <!--			<el-table height="90%" :data="nowPage" border highlight-current-row :cell-style="cellStyle" :header-cell-style="{background:'#F5F5F5',color:'#696969'}">-->
      <div class="lixt_box">
        <div class="right">
          <el-table height="80%" :data="list" border highlight-current-row :cell-style="cellStyle" stripe
            :span-method="objectSpanMethod" :header-cell-style="{background:'#F5F5F5',color:'#696969'}">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="index" width="90" label="序号"></el-table-column>
            <el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name" :key="item.key"
              :width="item.width">
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  isempty()
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  import request from "@/api/http.js";
  import {getAllTypeByGroup,getAppTypeByGroupId} from "../../api/energySubType";
  export default {
    components: {
      elCheckBoxTree,
    },
    data () {
      return {
        //合并表格
        columnArr: ["deviceName","deviceType"],
        spanArr: [], //临时组
        spanData: [], // 组合的合并组
        colom1: [0,6],
        colom2: [0,1,2,3,4,5,6],//合并行
        list: [],
        deviceNos: [],//设备数
        loading: false,
        value1: '',//时间
        value2: '',//时间
        timeInterval: 'monthrange',//日期类型
        apptypeValue: [],//应用类型组
        apptypeValue2: '',//应用类型
        options: [],//应用类型 数据 
        nowIndex: 0,
        nowApptypeGroups: [],
        from2name: {},
        columns: [{
          name: '设备名称',
          key: 'deviceName',
          width: 210
        },{
          name: '设备类型',
          key: 'deviceType'
        },{
          name: '时间',
          key: 'time'
        },{
          name: '最大值',
          key: 'max'
        },{
          name: '最大值时间',
          key: 'maxtime',
          width: 170
        },{
          name: '最小值',
          key: 'min'
        },{
          name: '最小值时间',
          key: 'mintime',
          width: 170
        }

        ]
      }
    },
    created () {
      debugPage=this
      //直接全选
      setTimeout(() => {
        this.apptypeValue=['全选'];
        this.selectAll();
      },1000)

    },
    mounted () {
      setTimeout(() => {
        this.realTimeValueStore.commit("removeKeys",this.nowVariableNames)
      },1000);
      return
      this.apptypeValue=this.nowSelectAppTypeGroupIds;


    },
    destroyed () {
      this.realTimeValueStore.commit("removeKeys",this.nowVariableNames)
    },
    computed: {
      transformerList () {
        return this.$store.cacheStore.state.transformerList
      },
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      nowVirtualDeviceList () {
        return this.$store.deviceStore.state.nowVirtualDeviceList
      },
      variableStore () {
        return this.$store.variableStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      variableTree () {
        if(isempty(this.nowVirtualDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowVirtualDeviceList.forEach(item => {
          var variableTree=[]
          if(item.type=="virtualDevice") {
            variableTree=this.variableStore.getters.getVariableTree(item.no)
          }
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      apptypeGroups () {
        //debugger
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        let list2=[]
        list.forEach(item => {
          if(item.name!="门限值") {
            list2.push(item)
          }
        })
        return list2.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
      },
      nowVariableNames () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            this.from2name[i.fromName]=i.name+'('+item.unit+')'
            v2.push(i.fromName)
          })
        })
        return v2
      },
      nowVariableList () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            i.devicename=item.devicename
            v2.push(i)
          })
        })
        v2.sort((a,b) => {
          return a.typeNo-b.typeNo
        })
        return v2
      },
      pageLen () {
        return this.dataList.length<20? this.dataList.length:20
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        return list
      },
      dataList () {
        //获取值
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNames)
        var deviceList=this.nowVariableNames.map(item => item.substring(0,item.indexOf('.'))).distinct()
        var deviceStateMap=this.realTimeValueStore.getters.getDeviceState(deviceList)
        var v2=this.realTimeValueStore.getters.getTime(this.nowVariableNames)
        //获取当前设备状态
        return this.nowVariableNames.map((item,index) => {
          var value=this.realTimeValueStore.getters.getText(item,vl[index])
          var deviceState='--'
          switch(deviceStateMap[item.substring(0,item.indexOf('.'))]) {
            case 0:
              deviceState='取消'
              break
            case 1:
              deviceState='正常'
              break
          }
          var getTime=v2[index]!=undefined? new Date(parseInt(v2[index])).format('yyyy-MM-dd hh:mm:ss'):'--'
          if(isNaN(parseFloat((vl[index])))||isnull(parseFloat((vl[index])))) {
            value="- -"
          }
          var name=this.from2name[item]? this.from2name[item]:item
          let deviceName=''
          //这样拿貌似也不行，里面数据有问题this.nowVariableList[index].fromName.split('.')[0]
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              //deviceName = item2.fromName.split('.')[0]
              deviceName=item2.deviceName;
            }
          })
          return {
            devicename: deviceName,
            variablename: name.subByFirstChar("."),
            value,
            getTime,
            deviceState,
          }
        })
      }
    },
    watch: {

      nowVariableNames (nv,ov) {
        // this.realTimeValueStore.commit("removeKeys",ov)
        // this.realTimeValueStore.commit("addKeys",nv)
      },
      apptypeValue (nv,ov) {
        if(nv.length==1) {
          getAppTypeByGroupId({'groupId': nv[0]}).then(res => {
            if(res.code==200) {
              this.options=res.data;
              this.apptypeValue2='';
            }
          })
        }
        // this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',nv)
        let list=[]
        if(!isempty(nv)) {
          nv.forEach(item => {
            this.apptypeGroups.forEach(item2 => {
              if(item==item2.id) {
                list.push(item2)
              }
            })
          })
        }
        this.nowApptypeGroups=list;
      },
      nowIndex () {
        this.nowPage
      }
    },
    methods: {
      // 计算需要合并的单元格
      getSpanData (data) {
        this.spanData=[];
        this.columnArr.forEach((element) => {
          let contactDot=0;
          this.spanArr=[];
          data.forEach((item,index) => {
            if(index===0) {
              this.spanArr.push(1);
            } else {
              if(item[element]===data[index-1][element]) {
                this.spanArr[contactDot]+=1;
                this.spanArr.push(0);
              } else {
                contactDot=index;
                this.spanArr.push(1);
              }
            }
          });
          this.spanData.push(this.spanArr);
        });
      },
      objectSpanMethod ({row,column,rowIndex,columnIndex}) {
        if(column.label=="设备类型"||column.label=='设备名称') {
          if(this.spanData[columnIndex-1][rowIndex]) {
            return {
              rowspan: this.spanData[columnIndex-1][rowIndex],
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      },
      // 合并单元格
      // objectSpanMethod ({row,column,rowIndex,columnIndex}) {
      //   if(columnIndex===2) {
      //     if(this.list.length>20) {
      //       return {
      //         rowspan: 1,
      //         colspan: 1
      //       };
      //     }
      //     if(this.colom2.includes(rowIndex)) {
      //       if(rowIndex&&this.colom2.indexOf(rowIndex)-this.colom2.indexOf(rowIndex-1)===1) {
      //         return {
      //           rowspan: 1,
      //           colspan: 1
      //         };
      //       }
      //       console.log(rowIndex,'rowIndex');
      //       return {
      //         rowspan: rowIndex||this.colom2[1],
      //         colspan: 1
      //       };
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       };
      //     }
      //   }
      //   if(columnIndex===1) {
      //     if(this.colom1.includes(rowIndex)) {
      //       return {
      //         rowspan: rowIndex||this.colom1[1],
      //         colspan: 1
      //       };
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       };
      //     }
      //   }
      // },

      //获取设备no
      getLoadValue () {
        var deviceNos='';
        this.nowVirtualDeviceList.forEach((item,index) => {
          if(this.nowVirtualDeviceList.length==index+1) {
            deviceNos+=item.no
          } else {
            deviceNos+=item.no+','
          }
        })
        this.deviceNos=deviceNos
      },
      // 获取数据
      getList (v) {
        this.getLoadValue();//获取设备no
        var params={
          bgTime: '',
          endTime: '',
          deviceNos: this.deviceNos,
          dateType: '',
          typeGroupIds: this.apptypeValue? this.apptypeValue.join(','):'',
          types: this.apptypeValue2.length? this.apptypeValue2.join(','):'',
        }
        if(this.apptypeValue.length!=1||!params.types) {
          delete params.types
        }

        if(this.timeInterval=='year') {
          params.dateType="YEAR";
          params.bgTime=this.value1? this.value1.getTime():'';
          params.endTime=this.value1? this.value2.getTime():'';
        }
        if(this.timeInterval=='monthrange') {
          params.dateType="MON";
          params.bgTime=this.value1? this.value1[0].getTime():'';
          params.endTime=this.value1? this.value1[1].getTime():'';
        }
        if(this.timeInterval=='daterange') {
          params.dateType="DAY";
          params.bgTime=this.value1? this.value1[0].getTime():'';
          params.endTime=this.value1? this.value1[1].getTime():'';
        }

        request({url: "/extreme/findMaxOrMin",method: "get",params}).then(res => {
          var d=[];
          var colom1=[];//合并第一行
          var colom2=[];//合并第二行
          var colom1Name=''
          var colom2Name='';
          if(res.code==500) {
            this.list=d;
            return
          }
          res.map((v,vi) => {
            v.extremeNumVOS.map((a,ai) => {
              a.issueValues.map((b,bi) => {
                if(colom1Name!=v.deviceName) {
                  colom1Name=v.deviceName;
                  colom1.push(d.length)
                }
                if(colom2Name!=a.deviceType) {
                  colom2Name=a.deviceType
                  colom2.push(d.length)
                }
                d.push({
                  deviceName: v.deviceName,
                  deviceType: a.deviceType,
                  max: b.max.toString(),
                  maxtime: b.maxtime? new Date(b.maxtime).format('yyyy-MM-dd hh:mm:ss'):'--',
                  min: b.min.toString(),
                  mintime: b.mintime? new Date(b.mintime).format('yyyy-MM-dd hh:mm:ss'):'--',
                  time: b.time
                })
              })
            })
          })
          d.map((v,i) => {
            v.index=i
          })
          this.list=d;

          this.getSpanData(d); //计算需合并的内容
        })
      },
      //下载excel文件
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 实时值'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"实时值报告")
      },
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          // this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=idList
        } else {
          this.nowApptypeGroup=[]
          // this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }
      },
      checkAppGroup (item) {
        //选中了app应用组
        this.nowApptypeGroups=item
      },
      //表格自定义样式
      cellStyle (row,column,rowIndex,columnIndex) {
        //根据状态显示颜色
        if(row.column.label==="通讯状态") {
          if(row.row.deviceState=='正常') {
            return 'color: #67C23A'
          } else {
            return 'color: #999999'
          }
        }
      },

    }
  }
</script>

<style scoped lang="scss">
  .lixt_box {
    display: flex;
    height: 100%;
  }

  .lixt_box .left {
    width: 200px;
  }

  .lixt_box .right {
    flex: 1;
  }

  .buttonLine {
    min-height: 50px;
    flex-wrap: wrap;
  }

  .miniWidth {
    width: 110px;
  }

  .box {
    margin-left: 10px;
  }

  .VirtualDeviceRTValue {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }

  .VirtualDeviceRTValueRigth {
    width: 100%;
    height: 100%;
    /*overflow: hidden;*/
    /* padding-bottom: 55px;
		margin-top: 70px; */
  }

  .el_Tree_Body {
    padding: 0 !important;
    height: 94.5%;
    border-top: 0;
    border-bottom: 0;
  }

  /deep/.el-tree {
    width: 2.65rem !important;
    min-width: 2.55rem !important;
  }

  .virtualDeviceRTValueBody {
    width: 100%;
    display: flex !important;
    /* align-items: center; */
    justify-content: space-between;
    background-color: white;
  }
</style>